import faker from 'faker';

import { WorkflowStateEnum } from '../workflow.constants';
import { IWorkflow, IWorkflowData } from '../workflow.types';
import { Workflow } from '../workflow';
import { createRange } from '@/utils/helpers';

export function createRandomWorkflow(): IWorkflowData {
  return {
    id: faker.datatype.number(),
    name: faker.random.word(),
    description: faker.random.words(),
    state: faker.datatype.number({
      min: WorkflowStateEnum.Draft,
      max: WorkflowStateEnum.Published
    })
  };
}

export const mockWorkflowsData: IWorkflowData[] = createRange(5).map(() =>
  createRandomWorkflow()
);

export const mockWorkflows = (
  data: IWorkflowData[] = mockWorkflowsData
): IWorkflow[] => data.map(item => new Workflow(item));
